module.exports = __webpack_public_path__ + "img/recharge_go-en.1cf65c5b.png";